import { useState, useEffect } from "react";
import api from "./api/client";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/session")
      .then((r) => { if (r.data.es_superadmin) setUsuario(r.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    await api.delete("/api/auth").catch(() => {});
    setUsuario(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600" />
      </div>
    );
  }

  return usuario
    ? <Dashboard usuario={usuario} onLogout={handleLogout} />
    : <Login onLogin={setUsuario} />;
}
